"use client";

import { createRestDataProviderClient } from "@providers/data-provider/rest-data-provider.client";
import { getFilterValue, parseFilter, transformQueryParamsWithoutLocale } from "@shared/utils";
import { ComboboxOption, RadioGroup, RadioGroupItem, SearchInput } from "@ubud-ui/react-ui-kit";
import { useQuery } from "@tanstack/react-query";
import { useRouter, useSearchParams } from "next/navigation";
import qs from "qs";
import { useState } from "react";

type Education = {
  name: string;
  level: number;
};

const FILTER_KEY = "education";

export function EducationLevelFilter({ path }: { path: string }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const parsedParams = qs.parse(searchParams.toString());

  const restDataProviderClient = createRestDataProviderClient();

  const [keyword, setKeyword] = useState<string>(
    parsedParams && parsedParams[FILTER_KEY] && Array.isArray(parsedParams[FILTER_KEY]) && parsedParams[FILTER_KEY]?.length > 0
      ? (parsedParams[FILTER_KEY][0] as any)?.label
      : "",
  );
  const { data: optionResult } = useQuery<{ data: Education[] }>({
    queryKey: ["vacancy-education-level-filter-", keyword],
    queryFn: () =>
      restDataProviderClient.custom({
        url: transformQueryParamsWithoutLocale(
          "/karirhub/v1/educations",
          keyword
            ? {
                keyword: keyword,
                limit: 5,
              }
            : {
                limit: 5,
              },
        ),
        method: "GET",
      }),
  });
  const options: ComboboxOption[] = optionResult?.data
    ? optionResult.data
        .filter((it, index, self) => index === self.findIndex((x) => x.level === it.level))
        .map((it) => ({
          value: it.level,
          label: it.name,
        }))
    : [];

  const handleSearch = (keyword: string) => {
    setKeyword(keyword);
  };

  const handleFilter = (option: ComboboxOption) => {
    const paramsString = searchParams.toString();

    const value = {
      id: option.value,
      label: option.label,
    };

    const params = parseFilter(FILTER_KEY, value, qs.parse(paramsString));

    router.push(`${path}?${qs.stringify(params, { skipNulls: true })}`, {
      scroll: false,
    });
  };

  const getValue = (value?: string) => {
    const params = qs.parse(searchParams.toString());

    return getFilterValue(params, FILTER_KEY, value);
  };

  return (
    <>
      <div className="ml-px mt-px">
        <SearchInput placeholder="Cari pendidikan" value={keyword} onSearch={handleSearch} />
      </div>
      {options && options.length > 0 ? (
        <RadioGroup
          defaultValue={getValue()?.id}
          onValueChange={(value) => handleFilter(options.find((it) => it.value == value) as ComboboxOption)}
        >
          <div className="space-y-3 pt-5 pb-2">
            {options.map((option, index) => {
              return (
                <div className="flex items-start gap-3" key={"education-level-" + option.value + "-" + index}>
                  <RadioGroupItem className="mt-1" id={"education-level-" + option.value + "-" + index} value={option.value.toString()} />
                  <label htmlFor={"education-level-" + option.value + "-" + index}>{option.label}</label>
                </div>
              );
            })}
          </div>
        </RadioGroup>
      ) : (
        <div className="text-center font-bold pt-5 pb-2">{!keyword ? "Ketik untuk mencari pendidikan" : "Pendidikan tidak ditemukan"}</div>
      )}
    </>
  );
}
